import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children, role }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex h-[60vh] items-center justify-center mono text-xs uppercase tracking-widest text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/TreeTopper" replace />;
  if (role === "admin" && user.role !== "admin") return <Navigate to="/" replace />;
  if (role === "wholesale" && !["wholesale", "admin"].includes(user.role)) return <Navigate to="/TradeAccount" replace />;
  if (role === "dropship" && !["dropship", "admin"].includes(user.role)) return <Navigate to="/TradeAccount" replace />;
  return children;
};
